import styled from "styled-components";
import { Button } from "@mui/material";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
  gap: 24px;
  background-color: #fff;

  @media (max-width: 768px) {
    padding: 16px;
    gap: 16px;
  }
`;

export const ContentHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  @media (max-width: 768px) {
    gap: 12px;
  }
`;

export const Title = styled.h1`
  font-family: 'Montserrat', sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: #0a1e3d;
  margin: 0;
`;

export const Subtitle = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  color: #666;
  margin: 0;
`;

export const SettingsCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px;
  background-color: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;

  @media (max-width: 768px) {
    padding: 16px;
    gap: 12px;
  }
`;

export const SettingsTitle = styled.h2`
  font-family: 'Montserrat', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #0a1e3d;
  margin: 0;
`;

export const SettingsDescription = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 13px;
  color: #666;
  margin: 0;
`;

export const RadioGroupContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  margin-top: 12px;
  flex-wrap: wrap;

  .MuiFormControlLabel-root {
    margin: 0;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
  }
`;

export const HelperText = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 12px;
  color: #999;
  margin: 8px 0 0 0;
  font-style: italic;
`;

export const FiltersAndStatsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;

  @media (max-width: 768px) {
    gap: 12px;
  }
`;

export const FilterRow = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
`;

export const StatusFilterContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const StatusPill = styled.button<{ isActive: boolean }>`
  padding: 8px 16px;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  background-color: ${props => (props.isActive ? '#0a1e3d' : '#fff')};
  color: ${props => (props.isActive ? '#fff' : '#0a1e3d')};
  font-family: 'Montserrat', sans-serif;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    border-color: #0a1e3d;
    background-color: ${props => (props.isActive ? '#0a1e3d' : '#f8f9fa')};
  }

  @media (max-width: 768px) {
    flex: 1;
    padding: 6px 12px;
    font-size: 12px;
  }
`;

export const StatusSummaryContainer = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: flex-end;

  @media (max-width: 768px) {
    justify-content: flex-start;
  }
`;

export const StatusSummaryChip = styled.div<{ type: 'pending' | 'approved' | 'rejected' }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  border-radius: 8px;
  background-color: ${props => {
    switch (props.type) {
      case 'pending':
        return '#fff4e6';
      case 'approved':
        return '#e8f5e9';
      case 'rejected':
        return '#ffebee';
      default:
        return '#f5f5f5';
    }
  }};
  border: 1px solid ${props => {
    switch (props.type) {
      case 'pending':
        return '#ffe0b2';
      case 'approved':
        return '#c8e6c9';
      case 'rejected':
        return '#ffcdd2';
      default:
        return '#e0e0e0';
    }
  }};
  min-width: 100px;
  text-align: center;

  @media (max-width: 768px) {
    min-width: 80px;
    padding: 8px 12px;
  }
`;

export const StatusSummaryLabel = styled.span`
  font-family: 'Montserrat', sans-serif;
  font-size: 12px;
  color: #666;
  margin-bottom: 4px;
  font-weight: 500;
`;

export const StatusSummaryCount = styled.span`
  font-family: 'Montserrat', sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #0a1e3d;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const TableCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background-color: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;

  @media (max-width: 768px) {
    padding: 12px;
  }
`;

export const TableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 12px;
  border-bottom: 1px solid #e0e0e0;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`;

export const TableTitle = styled.h3`
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #0a1e3d;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const ContentBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  width: 100%;
  flex-wrap: wrap;
  padding-top: 12px;
  border-top: 1px solid #e0e0e0;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    padding-top: 12px;
  }
`;

export const PaginationInfo = styled.div`
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  color: #0a1e3d;
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: 13px;
  }
`;

export const PaginationControls = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  button {
    font-size: 12px;
    padding: 6px 12px;
  }

  span {
    font-family: 'Montserrat', sans-serif;
    font-size: 13px;
    color: #0a1e3d;
    min-width: 80px;
    text-align: center;
  }

  @media (max-width: 768px) {
    width: 100%;
    flex-wrap: wrap;

    button {
      flex: 1;
      min-width: 70px;
      padding: 4px 8px;
      font-size: 11px;
    }

    span {
      flex: 1;
      min-width: 100%;
      text-align: center;
      font-size: 12px;
    }
  }
`;

export const PageSizeControl = styled.div`
  min-width: 150px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ActionsContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;

  button {
    font-size: 12px;
    padding: 6px 12px;
  }

  @media (max-width: 768px) {
    button {
      font-size: 11px;
      padding: 4px 8px;
    }
  }
`;

export const StatusBadge = styled.span<{ status: string }>`
  display: inline-block;
  padding: 6px 12px;
  border-radius: 12px;
  font-family: 'Montserrat', sans-serif;
  font-size: 12px;
  font-weight: 500;
  background-color: ${props => {
    switch (props.status) {
      case 'PENDING':
        return '#fff4e6';
      case 'APPROVED':
        return '#e8f5e9';
      case 'REJECTED':
        return '#ffebee';
      default:
        return '#f5f5f5';
    }
  }};
  color: ${props => {
    switch (props.status) {
      case 'PENDING':
        return '#f57c00';
      case 'APPROVED':
        return '#2e7d32';
      case 'REJECTED':
        return '#c62828';
      default:
        return '#666';
    }
  }};
`;

export const FilterContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }
`;

export const RestaurantCardsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 20px;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

export const RestaurantCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px;
  background-color: #fff;
  border: 1px solid #e8eef5;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #d4dce8;
  }

  @media (max-width: 768px) {
    padding: 16px;
    gap: 12px;
  }
`;

export const RestaurantHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-bottom: 1px solid #e8eef5;
  padding-bottom: 12px;
`;

export const RestaurantName = styled.h3`
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #0a1e3d;
  margin: 0;
  word-break: break-word;
`;

export const RestaurantLocation = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 13px;
  color: #666;
  margin: 0;
`;

export const RestaurantDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const DetailRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const DetailLabel = styled.span`
  font-family: 'Montserrat', sans-serif;
  font-size: 12px;
  color: #999;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
`;

export const DetailValue = styled.span`
  font-family: 'Montserrat', sans-serif;
  font-size: 13px;
  color: #0a1e3d;
  word-break: break-word;
`;

export const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
`;

export const CardActionsContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  margin-top: 8px;
  border-top: 1px solid #e8eef5;
  padding-top: 12px;

  @media (max-width: 768px) {
    gap: 6px;
  }
`;

export const ActionButton = styled(Button)`
  && {
    width: 100%;
    font-size: 13px;
    padding: 8px 12px;
    text-transform: none;
    font-weight: 600;

    @media (max-width: 768px) {
      padding: 6px 10px;
      font-size: 12px;
    }
  }
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  gap: 12px;
  text-align: center;
  width: 100%;
`;

export const EmptyStateText = styled.p`
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  color: #999;
  margin: 0;

  &:first-child {
    font-size: 16px;
    font-weight: 600;
    color: #0a1e3d;
  }
`;
